export default {
  noActiveCalls: 'No active calls',
  currentCall: 'Current Call',
  ringCall: 'Ringing Call',
  onHoldCall: 'Call on Hold',
  otherDeviceCall: 'Ongoing calls on my other devices',
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Add to conference call?',
  mergeToConference: 'Merge',
  conferenceCall: 'Conference Call',
} as const;
